import { memo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useSelector } from "react-redux";

import { TextCell } from "@similarweb/pro-logic-components";

import { benchmarkTrackerTracking } from "app/pages/benchmark-tracker/services/tracking";
import { selectSelectedBenchmark } from "app/pages/benchmark-tracker/store/selectors/entitySelectors";
import { translate } from "app/filters/i18nFilter";
import type { BenchmarkMetricName } from "app/pages/benchmark-tracker/types/api.types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { METRIC_PARAMS } from "../WebsiteWithFaviconCell/config";

import * as SC from "./styles";

type ColorDomainCellWithLinkSchema = {
    value: string;
    metricName?: BenchmarkMetricName;
    row: Record<PropertyKey, any>;
};

export const ColorDomainCellWithLink = memo(({ row, value, metricName }: ColorDomainCellWithLinkSchema) => {
    const { color, isPrimary } = row ?? {};

    const { params } = useCurrentStateAndParams();
    const selectedBenchmark = useSelector(selectSelectedBenchmark);
    const track = benchmarkTrackerTracking.metric;

    const onClick = async () => {
        if (metricName) {
            const primaryDomain = selectedBenchmark?.primaryDomains[0];

            const { country, granularity, duration, webSource } = params;
            const keyList = [primaryDomain];
            const newParams = { isWWW: "*", country, duration, granularity, webSource };

            const { state, additionalParams } = METRIC_PARAMS[metricName];

            if (!isPrimary) {
                keyList.push(value);
            }

            const key = keyList.join(",");
            track.trackLinkClick(isPrimary ? "primary" : "competitor", metricName);

            await proNavigator.go(state, { ...newParams, ...additionalParams, key });
        }
    };

    const cellValue = isPrimary ? (
        <SC.TextContainer isPrimary={isPrimary}>
            {translate("activation.common.your-domain", {
                domain: value,
            })}
        </SC.TextContainer>
    ) : (
        <SC.TextContainer>{value}</SC.TextContainer>
    );
    return (
        <SC.CellContainer onClick={onClick}>
            <SC.ColorContainer color={color} />
            <TextCell>{cellValue}</TextCell>
        </SC.CellContainer>
    );
});

ColorDomainCellWithLink.displayName = "ColorDomainCellWithLink";
